import { containsV1inPath, envFlags, FLAGS, getQueryParamsAndQueryString, } from '@thoughtspot/env-flags';
import { GlobalAlert } from '@thoughtspot/global-alert';
import { useTranslation } from '@thoughtspot/i18n';
import { collectEvent, UserAction, userActionTypeEnum, } from '@thoughtspot/metrics';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useBlinkContextForGlobalNav } from "../../contexts/global-nav-blink-context";
import { useGetUserAccessibleOrgsByParamsQuery, useSwitchOrgMutation, } from "../../services/orgs/orgs-service";
import { accessibleOrgParams, OrgMenu } from "./org-menu";
const IS_ORG_SWITCHED_AND_PAGE_REFRESHED = 'isOrgSwitchedAndPageRefreshed';
export const OrgMenuContainer = ({ isLegacy, }) => {
    const { t } = useTranslation();
    const { sessionService, navService } = useBlinkContextForGlobalNav();
    const { getCurrentOrgId, isReactshellEnabled } = sessionService;
    const [message, setMessage] = useState('');
    const [selectedOrgId, setSelectedOrgId] = useState('');
    const [isToastAlertVisible, setIsToastAlertVisible] = useState(false);
    const areProfileAndHelpHidden = sessionService.areProfileAndHelpHidden();
    const { data: orgsList, refetch } = useGetUserAccessibleOrgsByParamsQuery({
        ...accessibleOrgParams,
    });
    const logMixPanelEvent = (userActionType) => {
        const selectedOrgObject = orgsList?.Data.orgs.filter((org) => org.orgId === selectedOrgId);
        const userAction = new UserAction(userActionType);
        collectEvent(userAction, {
            timestamp: Date.now(),
            toOrgId: selectedOrgObject[0].orgId,
            toOrgName: selectedOrgObject[0].orgName,
        });
    };
    const goToHomeAfterOrgSwitch = () => {
        const homePath = '/home';
        const { queryParams: originalParams } = getQueryParamsAndQueryString();
        const { [FLAGS.overrideOrgId.name]: deletedProp, ...queryParams } = originalParams;
        const orgQueryParamPresent = deletedProp !== undefined;
        let queryString = Object.keys(queryParams)
            .map(key => {
            if (queryParams[key]) {
                return `${key}=${queryParams[key]}`;
            }
            return '';
        })
            .filter(part => part)
            .join('&');
        if (queryString.length)
            queryString = `?${queryString}`;
        if (!orgQueryParamPresent &&
            navService.getCurrentPathByLocationHash(false) === homePath)
            window.location.reload();
        else if (isReactshellEnabled() && containsV1inPath()) {
            window.open(`/${queryString}#${homePath}`, '_self');
            return;
        }
        window.open(`${window.location.pathname}${queryString}#${homePath}`, '_self');
        if (!orgQueryParamPresent) {
            window.location.reload();
        }
    };
    const onSuccessSwitchOrg = (isSwitched) => {
        if (isSwitched) {
            localStorage.setItem(IS_ORG_SWITCHED_AND_PAGE_REFRESHED, 'true');
            logMixPanelEvent(userActionTypeEnum.SWITCH_ORG);
            goToHomeAfterOrgSwitch();
        }
    };
    const [switchOrg, switchOrgObj] = useSwitchOrgMutation(onSuccessSwitchOrg, err => {
        logMixPanelEvent(userActionTypeEnum.SWITCH_ORG_FAILURE);
    }, selectedOrgId);
    useEffect(() => {
        if (orgsList) {
            const isPageRefreshed = localStorage.getItem(IS_ORG_SWITCHED_AND_PAGE_REFRESHED);
            if (isPageRefreshed) {
                let currentOrgId = getCurrentOrgId();
                if (sessionService.isOrgPerUrlEnabled()) {
                    const overrideOrgId = envFlags.getValue(FLAGS.overrideOrgId.name);
                    if (overrideOrgId >= 0) {
                        currentOrgId = overrideOrgId;
                    }
                }
                const selectedOrgObject = orgsList?.Data.orgs.filter((org) => org.orgId === _.toString(currentOrgId));
                localStorage.removeItem(IS_ORG_SWITCHED_AND_PAGE_REFRESHED);
                setMessage(selectedOrgObject[0].orgName);
                setIsToastAlertVisible(true);
            }
        }
    }, [selectedOrgId, orgsList]);
    useEffect(() => {
        if (selectedOrgId) {
            switchOrg();
        }
    }, [selectedOrgId]);
    return (React.createElement(React.Fragment, null,
        !sessionService.isOrgSwitcherHidden() && (React.createElement(OrgMenu, { getCurrentOrgId: getCurrentOrgId, orgsListData: orgsList?.Data.orgs.filter((org) => org.isActive), setSelectedOrgId: setSelectedOrgId, refetch: refetch, selectedOrgId: selectedOrgId, isLegacy: isLegacy, isOrgPerUrlEnabled: sessionService.isOrgPerUrlEnabled(), areProfileAndHelpHidden: areProfileAndHelpHidden, getSubDomainIfOrgEnabled: navService.getSubDomainIfOrgEnabled })),
        React.createElement(GlobalAlert.Toast, { message: t('orgSwitcher.successToastMessage', {
                orgName: message,
            }), isVisible: isToastAlertVisible, onClose: () => setIsToastAlertVisible(false), autoHide: true })));
};
//# sourceMappingURL=org-menu.container.js.map